/* import __COLOCATED_TEMPLATE__ from './list.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import PowerSelectOptions from 'ember-power-select/components/power-select/options';
import { tracked } from '@glimmer/tracking';
import Ember from 'ember';
let PowerSelectOptionsList = (_class = class PowerSelectOptionsList extends PowerSelectOptions {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "args", void 0);
    // internal api
    _defineProperty(this, "listElement", null);
    _initializerDefineProperty(this, "isTopLevelList", _descriptor, this);
    _defineProperty(this, "intersectionObserver", null);
    _defineProperty(this, "lastListElement", null);
    this.args = args;
  }
  get useVerticalCollection() {
    if (Ember.testing) {
      return false;
    }
    return this.args.useVerticalCollection ?? false;
  }
  get verticalCollectionOptions() {
    let isSelectedOptionString = typeof this.args.select.selected === 'string';
    return {
      key: isSelectedOptionString ? '@identity' : this.args.extra.valueProperty,
      idForFirstItem: isSelectedOptionString ? this.args.select.selected : this.args.select.selected?.[this.args.extra.valueProperty],
      bufferSize: this.args.verticalCollectionOptions?.bufferSize ?? 10,
      estimateHeight: this.args.verticalCollectionOptions?.estimateHeight ?? 32.5,
      staticHeight: this.args.verticalCollectionOptions?.staticHeight ?? false,
      renderAll: this.args.verticalCollectionOptions?.renderAll ?? false
    };
  }
  getLastListElement() {
    if (this.listElement == null) {
      return null;
    }
    let items = this.listElement.querySelectorAll('[data-power-select-list-content-option]');
    if (items.length === 0) {
      return null;
    }
    return items[items.length - 1];
  }
  setupIntersectionObserver() {
    let currentLastListElement = this.getLastListElement();
    // if the last element was already observed do nothing
    // we don't want to go into an infinite loop of observing the last element on every re-render
    if (currentLastListElement === this.lastListElement || currentLastListElement == null) {
      return;
    }
    this.lastListElement = currentLastListElement;
    if (this.intersectionObserver != null) {
      this.intersectionObserver.disconnect();
    }
    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '0px',
      threshold: 0
    });
    this.intersectionObserver.observe(this.lastListElement);
  }
  handleIntersection(entries) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        this.intersectionObserver?.unobserve(entry.target);
        this.args.select.actions.loadNext();
        break;
      }
    }
  }
  onInsert(element) {
    let {
      actions,
      uniqueId
    } = this.args.select;
    if (element.getAttribute('role') === 'listbox') {
      this.isTopLevelList = true;
    }
    if (this.isTopLevelList) {
      if (this.args.extra.matchContentWidth) {
        actions.resizeDropdownContent();
      }
      if (this.args.extra.onScrollEnd != null) {
        let optionsListElement = document.getElementById(`ember-power-select-options-${uniqueId}`);
        if (optionsListElement != null) {
          this.listElement = optionsListElement;
          this.setupIntersectionObserver();
        }
      }
    }
  }
  willDestroy() {
    super.willDestroy();
    this.intersectionObserver?.disconnect();
  }
  onMouseDown(event) {
    if (this.args.onOptionsMouseDown != null) {
      this.args.onOptionsMouseDown(event);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isTopLevelList", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setupIntersectionObserver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupIntersectionObserver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntersection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntersection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseDown"), _class.prototype)), _class);
export { PowerSelectOptionsList as default };